import React from 'react'
import axios from 'axios'
import CustomModal from './customModal'

export default class Footer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            online: false,
            isOpen: false
        }
    }

    componentDidMount() {
        this.fetchOnlineStatus() // First fetch
        setInterval(() => {
            this.fetchOnlineStatus()
        }, 30000); // every 30 seconds, checking if (online)
    }

    fetchOnlineStatus = () => {
        axios.get(`${document.location.pathname}?param=${new Date()}`) // Fetching yourself , if the server response, you are online
            .then(() => {
                this.setState({ online: true })
            })
            .catch(err => {
                this.setState({ online: false })
            })
    }

    toggleModal = () => {
        this.setState({ isOpen: true })
    }

    render() {
        return (
            <div className="footer">
                {this.state.online ?
                    <p>Status : <span className="success"><b>online</b></span></p>
                    :
                    <p>Status : <span className="alert"><b>disconnected</b></span></p>
                }
                <div id="new-content-available" className="hidden" onClick={this.toggleModal}>New version available !</div>
                <CustomModal title="New version available" isOpen={this.state.isOpen}>
                    <p>There is a <b>new version of the application</b> available !</p>
                    <p>You should <b>close all the tabs</b> of the application and <b>reopen</b> it in your browser !</p>
                </CustomModal>
            </div>
        )
    }
}